import React from 'react';

type Props = {
  pageHeader?: React.ReactNode;

  contentHeader?: React.ReactNode;
  children?: React.ReactNode;

  sidebar?: React.ReactNode;
};

// From lg up the content and the sidebar are two panes side by side that scroll on their own; below
// it the sidebar follows the content and the page scrolls both.
export function ContentCloudDetailsPageLayout({ pageHeader, sidebar, contentHeader, children }: Props) {
  return (
    <div className="d-flex flex-column">
      <div className="flex-grow-0 flex-shrink-0">
        <div className="pt-3 ps-3 pe-3 pb-1">{pageHeader}</div>
      </div>

      <div className="flex-grow-1 flex-shrink-1 min-height-0 flex-basis-100">
        <div className="d-flex flex-column flex-lg-row">
          <div className="content-cloud-details-pane flex-grow-1 flex-shrink-1 min-width-0">
            <div className="d-flex flex-column h-100">
              {contentHeader && <div className="flex-grow-0 flex-shrink-0">{contentHeader}</div>}
              <div className="flex-grow-1 flex-shrink-1 min-height-0 flex-basis-100 overflow-auto px-4">{children}</div>
            </div>
          </div>
          {sidebar && (
            <div className="content-cloud-details-sidebar flex-grow-0 flex-shrink-0 px-3">
              <div className="overflow-auto h-100">{sidebar}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
